module.exports = __webpack_public_path__ + "static/img/banner02.cb9c96e4.jpg";